module.exports = __webpack_public_path__ + "img/douyin@2X.ff9982c4.png";